import React from 'react';

const CompetitionsSection: React.FC = () => {
  const competitions = [
    { name: 'Champions League', country: null, flag: '🏆', count: 6 },
    { name: 'Championship', country: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', count: 12 },
    { name: 'League One', country: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', count: 4 },
    { name: 'Premier League', country: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', count: 21 },
    { name: 'Bundesliga', country: 'Deutschland', flag: '🇩🇪', count: 9 },
    { name: 'La Liga', country: 'Spanien', flag: '🇪🇸', count: 10 },
  ];

  return (
    <section className="px-3 py-4">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-base font-black text-gray-900">Top-Wettbewerbe</h2>
        <button className="flex items-center gap-1 text-sm font-semibold text-gray-700">
          Alle
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      <div className="bg-white rounded-2xl overflow-hidden shadow-sm">
        {competitions.map((comp, idx) => (
          <button
            key={comp.name}
            className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-50 transition ${
              idx < competitions.length - 1 ? 'border-b border-gray-100' : ''
            }`}
          >
            <span className="text-xl w-7 text-center flex-shrink-0">{comp.flag}</span>
            <div className="flex-1">
              <p className="text-sm font-semibold text-gray-900">{comp.name}</p>
              {comp.country && <p className="text-xs text-gray-500">{comp.country}</p>}
            </div>
            <span className="text-sm font-semibold text-gray-700">{comp.count}</span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default CompetitionsSection;
